import { render, staticRenderFns } from "./TipoMovimiento.vue?vue&type=template&id=60d8fe0a"
import script from "./TipoMovimiento.vue?vue&type=script&lang=js"
export * from "./TipoMovimiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports